export enum PaymentWorkflow {
  PAYMENT_PLAN = "payment_plan",
  PAYMENT_FLOW = "payment_flow",
}

export enum WalletName {
  APPLE_PAY = "Apple Pay",
  GOOGLE_PAY = "Google Pay",
  CARD = "Card",
}

export enum LoginMethod {
  PUBLIC = "PUBLIC",
  TOKENIZED = "TOKENIZED",
}
